const initialState = {
    subdomain: '',
  };
  
  const subdomainReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_SUBDOMAIN':
        return {
          ...state,
          subdomain: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default subdomainReducer;
  